import { createPageTableSchema } from '@state/_shared/tableComponentStateSchema';

// Define the specific structure for a row in the orders table
const ordersRowSchema = {
    type: 'object',
    properties: {
        // Core identifier
        id: { type: ['string', 'number'], default: '' },

        // Order details
        platform_order_id: { type: 'string', default: '' },
        date_ordered: { type: ['string', 'null'], default: null },
        status: { type: 'string', default: '' },
        buyer_name: { type: ['string', 'null'], default: null },
        total_price: { type: ['string', 'number', 'null'], default: null },
        total_count: { type: ['number', 'null'], default: null },
        unique_count: { type: ['number', 'null'], default: null }
    }
};

// Create the table schema specific to this page (read-only — no row actions)
const pageTableSchema = createPageTableSchema(ordersRowSchema);

// Orders default to the newest order on top. The nested property defaults
// must match because state initialization merges them over the object default.
pageTableSchema.properties.sorting.default = {
    sortBy: 'date_ordered',
    sortDirection: 'desc'
};
pageTableSchema.properties.sorting.properties.sortBy.default = 'date_ordered';
pageTableSchema.properties.sorting.properties.sortDirection.default = 'desc';

// Schema definition for orders page state
export const ordersPageStateSchema = {
    // Table State (using the shared schema)
    table: pageTableSchema
};

export default ordersPageStateSchema;
